import React, {ReactNode} from "react";
import {ChatTokenContextType} from "../types/chat-token-context";


export const ChatTokenContext = React.createContext<ChatTokenContextType>({} as ChatTokenContextType)

export function ChatTokenContextProvider({ children }:{children: React.ReactNode}): ReactNode {
  const [chatToken, setChatToken] = React.useState<string>()
  const [userId, setUserId] = React.useState<string>()


  return <ChatTokenContext.Provider value={{
    chatToken,
    setChatToken,
    userId,
    setUserId,
  }}>
    {children}
  </ChatTokenContext.Provider>
}